<template>
   <v-app>
      <div class="animated fadeIn">

         <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

         <div>
            <v-row>
               <v-col>
                  <ddoSelectSwitchCustomer ref="mySelect"
                     @switchCustomer="refresh_page"
                  >
                  </ddoSelectSwitchCustomer>
               </v-col>
            </v-row>
         </div>

         <CardUpdatableCustomercustomer ref="myCustomercustomer" :row="levels[0].row" :depth="levels[0].level" :level="levels[0]"
            @errors="refresh_errors"
         />
         
      </div>
   </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import BasicList from '@/views/BasicList.vue';
import ddoSelectSwitchCustomer from '@/components/ddoSelectSwitchCustomer.vue'
import CardUpdatableCustomercustomer from '@/components/partials/CardUpdatableCustomercustomer.vue';
import ddoClientList from '@/components/ddoClientList.vue';

Vue.use(ddoClientList);

let initial_row = {}

export default {
   name: 'customer',
   mixins: [BasicList],
   components: {
      ddoAlert,
      ddoSelectSwitchCustomer,
      CardUpdatableCustomercustomer,
      ddoClientList,
   },

   data: () => {
      return {
         _this: null,
         loading: false,
         session_row: null,

         /* 
         * LEVEL 1 : all for ddoClientList : columns, options, callbacks
         */
         levels: [

         {
            api_code: 'customer',
            api_prefix: 'cus',
            row: { ctc_general: {}, ctc_billing: {}, ctc_shipping: {} },
            level: 0,
            errors: [],
            callbacks: {
            },
            dialogOptions: {
               codeRules : [
                  (v) => !!v || i18n.t('texts._required')
               ]
            },
            dialogValues: {
               headers: {
                  select: i18n.t('texts.cus_select_title'),
                  create: i18n.t('texts.cus_create_title'),
                  update: i18n.t('texts.cus_update_title'),
                  delete: i18n.t('texts.cus_delete_title'),
               },
               texts: {
                  create_item: i18n.t('texts.cus_create_item'),
               },
               dialogShow: false,
               form_disabled: false,
               readonly: false,
               header_value_function: function(row) { return row['cus_code']; }
            },
         },

         ],

         useVuex: false,
         theme: 'bootstrap4',
         template: 'default',
      }
   },

   async created() {
      this._this = this;
      await this.get_session();
      await this.get_row();
      await this.$refs.myCustomercustomer.refresh_rows_all(this.levels[0].row);
   },

   methods: {

      async refresh_page(session_row) {
         this.session_row = session_row;
         this.levels[0].session_row = session_row;
         await this.get_row();
         await this.$refs.myCustomercustomer.refresh_rows_all(this.levels[0].row);
         //await this.$refs.myCustomercustomer.refresh_rows();
      },

      async get_session() {
         var { errorinfos, api_response } = await this.$api._get_session(this.$router);
         if ( api_response.error==0 && api_response.row ) {
            this.session_row = api_response.row;
         } else {
            this.session_row = null;
         }
      },

      add_values_to_row(row) {
         if ( row.ctc_general==null  ) { row.ctc_general  = {}; }
         if ( row.ctc_billing==null  ) { row.ctc_billing  = {}; }
         if ( row.ctc_shipping==null ) { row.ctc_shipping = {}; }
         row.ctc_general.marker = 'general';
         row.ctc_billing.marker = 'billing';
         row.ctc_shipping.marker = 'shipping';
         if ( row.ctc_pk_general!=null && row.ctc_pk_invoicing!=null && row.ctc_pk_general==row.ctc_pk_invoicing ) {
            row.ctc_billing_same_as_general = true;
         } else {
            row.ctc_billing_same_as_general = false;
         }
         if ( row.ctc_pk_invoicing!=null && row.ctc_pk_shipping!=null && row.ctc_pk_invoicing==row.ctc_pk_shipping ) {
            row.ctc_shipping_same_as_billing = true;
            row.ctc_shipping_same_as_general = false;
         } else if(row.ctc_pk_general!=null && row.ctc_pk_shipping!=null && row.ctc_pk_general==row.ctc_pk_shipping ) {
            row.ctc_shipping_same_as_general = true;
         } else {
            row.ctc_shipping_same_as_billing = false;
         }
      },

      async get_row() {
         if ( this.session_row!=null ) {
            console.log('get_row, session='+JSON.stringify(this.session_row))
            this.loading = true;
            let { errorinfos, api_response } = await this.$api.getRow(this.$router,this.levels[0].api_code,this.session_row.cus_pk_customer);
            if ( api_response.error==0 && api_response.row ) {
               this.add_values_to_row(api_response.row);
               console.log('get_row, api_response.row='+JSON.stringify(api_response.row));
               this.levels[0].row = api_response.row;
            }
            this.loading = false;
         }
      },

      /*
       * This function does nothing. It is required for provide/inject logic, in CardUpdatableFooter
       */
      async refresh_rows(key=null) {
      },

      prepare_create(parentKey=null) {
      },

      async prepare_update(parentKey=null) {
      },

      async prepare_delete(parentKey=null) {
      },

      async refresh_session() {
         var { errorinfos, api_response } = await this.$api._get_session(this.$router);
         if ( api_response.error==0 && api_response.row ) {
            console.log('refresh_session, row='+JSON.stringify(api_response.row));
            for ( var i=0; i<this.$refs.length; i++ ) {
            }
         }
      },

      recompute_values() {
         if ( this.session_row!=null ) {
            var readonly = this.session_row.cut_is_customer;
            this.levels[0].dialogValues.readonly = readonly;
            this.levels[1].dialogValues.readonly = readonly;
         }
      },

      show_dialog(level,show) {
         let _dV = this.levels[level].dialogValues;
         _dV.header_value = _dV.header_value_function(this.levels[level].row);
         if ( level==1 ) {
            _dV.dialogShow = { smtppro: false, exchange: false };
            if ( this.levels[level].row.plf_smtplike ) {
               _dV.dialogShow.smtppro = show;
            }
            if ( this.levels[level].row.plf_exchangelike ) {
               _dV.dialogShow.exchange = show;
            }
         } else {
            _dV.dialogShow   = show;
         }
         this.levels[level].dialogValues = _dV;
      },

      hide_dialog(level) {
         this.show_dialog(level,false);
      },

   },

   provide: function() {
      return {
         refresh_rows: this.refresh_rows
      }
   }

}
</script>